'use client';

import { Maximize2, X } from 'lucide-react';
import { useGuidedTour } from './GuidedTourProvider';
import { Button } from '@/components/ui/button';

export function GuidedTourMinimized() {
  const { isOpen, engine, currentStep, selectedFlow, closeTour } = useGuidedTour();

  if (!isOpen || !engine.isMinimized) {
    return null;
  }

  return (
    <div className="pointer-events-auto fixed bottom-4 right-4 z-[70] flex items-center gap-1.5">
      <Button
        variant="default"
        size="sm"
        className="h-10 gap-2 rounded-full px-4 shadow-lg dark:bg-slate-800 dark:text-slate-100"
        onClick={engine.restore}
        title="Resume tour"
      >
        <Maximize2 className="h-4 w-4" />
        <span className="max-w-[10rem] truncate">
          {currentStep?.title ?? selectedFlow?.label ?? 'Resume tour'}
        </span>
      </Button>
      <Button
        variant="default"
        size="icon"
        className="h-10 w-10 rounded-full shadow-lg dark:bg-slate-800 dark:text-slate-100"
        onClick={closeTour}
        title="Close tour"
        aria-label="Close tour"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
